import { render, staticRenderFns } from "./Ifexistredirct.vue?vue&type=template&id=63083227&"
import script from "./Ifexistredirct.vue?vue&type=script&lang=js&"
export * from "./Ifexistredirct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Ifexistredirct.vue"
export default component.exports